import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService, ToastPackage, Toast } from 'ngx-toastr';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'wire-toaster',
  templateUrl: './wire-toaster.component.html',
  styleUrls: ['./wire-toaster.component.scss'],
  standalone: true,
  imports: [CommonModule],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({
        opacity: 0,
      })),
      transition('inactive => active', animate('400ms ease-out', keyframes([
        style({
          transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
          opacity: 0,
        }),
        style({
          transform: 'skewX(20deg)',
          opacity: 1,
        }),
        style({
          transform: 'skewX(-5deg)',
          opacity: 1,
        }),
        style({
          transform: 'none',
          opacity: 1,
        }),
      ]))),
      transition('active => removed', animate('400ms ease-out', keyframes([
        style({
          opacity: 1,
        }),
        style({
          transform: 'translate3d(100%, 0, 0) skewX(30deg)',
          opacity: 0,
        }),
      ]))),
    ]),
  ],
  preserveWhitespaces: false,
})
export class WireToasterComponent extends Toast{
  constructor(
    toastrService: ToastrService,
    toastPackage: ToastPackage
  ) {
    super(toastrService, toastPackage);
  }

}
